export default __webpack_public_path__ + "static/media/san_lorenzo.c57a88f0.jpg";